import React from 'react';
import StyledPaper from 'views/rebranded-module/common/components/UI/NewMainWidget/NewAutoCompleteMenu/NewAutoCompleteMenu.styles';

const NewAutoCompleteMenu = ({ children, ...restOfProps }) => (
  <StyledPaper className="customDropDown" {...restOfProps}>
    {children}
  </StyledPaper>
);
export { NewAutoCompleteMenu };
